import { render, staticRenderFns } from "./VehicleTypeDropdownModal.vue?vue&type=template&id=394406ce"
import script from "./VehicleTypeDropdownModal.vue?vue&type=script&lang=js"
export * from "./VehicleTypeDropdownModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports